export default __webpack_public_path__ + "d8872b2170f87e73c7987b153bbc053e.woff";